"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 4.3h.729a4 4 0 0 1 2.309.734l.443.313a2 2 0 0 0 1.155.367H17a4 4 0 0 1 4 4V15.7a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V8.3a4 4 0 0 1 4-4Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--neutral--00,#ffffff))",
  fillRule: "evenodd",
  d: "M11.49 8.934a.796.796 0 0 1 1.02 0l.948.789a.796.796 0 0 1 0 1.224l-.949.79a.796.796 0 0 1-1.018 0l-.949-.79a.796.796 0 0 1 0-1.224l.949-.789Zm-3.004 2.4a.796.796 0 0 1 1.018 0l.949.788a.796.796 0 0 1 0 1.225l-.949.788a.796.796 0 0 1-1.018 0l-.949-.788a.796.796 0 0 1 0-1.225l.949-.789Zm6.01 0a.796.796 0 0 1 1.018 0l.949.788a.796.796 0 0 1 0 1.225l-.949.788a.796.796 0 0 1-1.018 0l-.949-.788a.796.796 0 0 1 0-1.225l.949-.789Zm-3.005 2.398a.796.796 0 0 1 1.018 0l.949.789a.796.796 0 0 1 0 1.225l-.949.788a.796.796 0 0 1-1.018 0l-.949-.788a.796.796 0 0 1 0-1.225l.949-.789Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkAppFolderFillIcon24.js.map